import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { UserserviceService } from "src/app/Services/userservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { DataService } from "src/app/Services/dataservice.service";
import {
  canBuildConsultationCalendarEvent,
  getConsultationStartEnd,
} from "src/app/utils/consultation-calendar.util";
import { ConsultationCalendarDialogService } from "src/app/Services/consultation-calendar-dialog.service";
import { getConsultationDashboardPath } from "src/app/utils/consultation-notification-nav.util";
import { shouldAvatarOpenProfile } from "src/app/utils/notification-avatar-nav.util";
import { OrgContextService } from "src/app/Services/org-context.service";
import { OrgNotificationService } from "src/app/Services/org-notification.service";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  readonly defaultProfileImageUrl = "assets/images/2.png";
  private orgContextSub: Subscription | null = null;
  /** Account scope (public / org id) the list was last fetched for. */
  private notificationsScopeKey: string | null = null;

  showNotificationCount: boolean;
  notificationCount: number;
  profilePicture: string;
  userDisplayName: any;
  userData: any;
  showDefaultImage: boolean;
  email: any;
  phone: any;
  info: any;
  website: any;
  uname: any;
  name: any;

  // Notification properties
  notificationsarray: any[] = [];
  notificationsToday: any[] = [];
  notificationsYesterday: any[] = [];
  notificationsThisWeek: any[] = [];
  notificationsOlder: any[] = [];
  noResultReturned: boolean = false;
  isthereanyNotifications: boolean = false;

  // Date helpers
  today: Date = new Date();
  yesterday: Date = new Date();
  thisWeekStart: Date = new Date();

  constructor(
    private router: Router,
    private userserviceService: UserserviceService,
    private flowServiceService: FlowServiceService,
    private cdr: ChangeDetectorRef,
    private dataService: DataService,
    private toastr: ToastrService,
    private consultationCalendarDialog: ConsultationCalendarDialogService,
    private orgContext: OrgContextService,
    private orgNotificationService: OrgNotificationService
  ) {
    // Initialize date helpers
    this.today.setHours(0, 0, 0, 0);
    this.yesterday.setDate(this.yesterday.getDate() - 1);
    this.yesterday.setHours(0, 0, 0, 0);
    const dayOfWeek = this.today.getDay();
    this.thisWeekStart.setDate(this.today.getDate() - dayOfWeek);
    this.thisWeekStart.setHours(0, 0, 0, 0);
  }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.showNotificationCount = false;
    this.notificationCount = 0;

    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
      this.noResultReturned = true;
      // Fetch once the account type is resolved, and again whenever it changes.
      this.orgContextSub = this.orgContext.watch().subscribe((state) => {
        if (
          state.loaded &&
          this.orgContext.accountScopeKey() !== this.notificationsScopeKey
        ) {
          this.getnotification();
        }
      });
    } else {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }

    this.getProfileUser();
  }

  ngOnDestroy(): void {
    this.orgContextSub?.unsubscribe();
  }

  getnotification() {
    const scopeKey = this.orgContext.accountScopeKey();
    this.notificationsScopeKey = scopeKey;
    this.noResultReturned = true;
    this.notificationsarray = [];

    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      pageIndex: 0,
    });

    this.flowServiceService.getNotifications(flowQueryModel).subscribe(
      (data) => {
        // Account type changed while this request was in flight.
        if (scopeKey !== this.notificationsScopeKey) {
          return;
        }
        this.isthereanyNotifications = true;
        this.noResultReturned = false;

        const visible = (data || []).filter((element) =>
          this.orgContext.isNotificationVisible(element)
        );
        if (visible.length > 0) {
          visible.forEach((element) => {
            var notification = {
              notification: {
                CreatedDate: this.timeAgo(element.createdDate),
                OriginalCreatedDate: element.createdDate,
                ProfilePicUrl: element.notifierProfilePicUrl,
                NotifierUserName: element.notifierUserName,
                NotificationSeen: element.notificationSeen,
                Message: element.message,
                ContentId: element.contentId,
                ContentTitle: element.contentTitle,
                FlowUrl: element.flowUrl,
                FlowId: element.notifierCustomerId,
                ContentType: element.contentType,
                ConsultationNavTarget: element.consultationNavTarget,
                ConsultationCalendarDate: element.consultationCalendarDate,
                ConsultationCalendarTime: element.consultationCalendarTime,
                ConsultationCalendarSlot: element.consultationCalendarSlot,
                IsNavigationDisabled: !!element.isNavigationDisabled,
                NotifierUserEmail: element.notifierUserEmail,
                VideoFlowPosterImageUrl: element.videoFlowPosterImageUrl,
                OrganizationId: element.organizationId,
                NavigationUrl: element.navigationUrl,
                PartitionKey: element.partitionKey,
                RowKey: element.rowKey,
              },
            };
            this.notificationsarray.push(notification);
          });

          // Sort notifications by actual date (newest first)
          this.notificationsarray.sort((a, b) => {
            const dateA = this.parseRelativeTime(
              a.notification.OriginalCreatedDate || a.notification.CreatedDate
            );
            const dateB = this.parseRelativeTime(
              b.notification.OriginalCreatedDate || b.notification.CreatedDate
            );
            return dateB.getTime() - dateA.getTime();
          });

          this.categorizeNotifications();
          this.notificationCount = this.notificationsarray.filter(
            (notification) => !notification.notification.NotificationSeen
          ).length;

          if (this.notificationCount > 0) {
            this.showNotificationCount = true;
          } else {
            this.showNotificationCount = false;
          }
        } else {
          this.isthereanyNotifications = false;
        }
        this.cdr.detectChanges();
      },
      (error) => {
        this.noResultReturned = false;
        this.isthereanyNotifications = false;
        this.cdr.detectChanges();
      }
    );
  }

  timeAgo(createdDate: string): string {
    if (!createdDate) return "Unknown time";

    const currentTime = new Date();
    const notificationTime = new Date(createdDate);

    if (isNaN(notificationTime.getTime())) {
      return "Unknown time";
    }

    const timeDifference = currentTime.getTime() - notificationTime.getTime();

    if (timeDifference < 0) {
      return "Just now";
    }

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) {
      return `${years} year${years > 1 ? "s" : ""} ago`;
    } else if (months > 0) {
      return `${months} month${months > 1 ? "s" : ""} ago`;
    } else if (weeks > 0) {
      return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
    } else if (days > 0) {
      return `${days} day${days > 1 ? "s" : ""} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else {
      return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
    }
  }

  parseRelativeTime(relativeTime: string): Date {
    // If it's already an ISO date string, parse it directly
    if (
      relativeTime &&
      relativeTime.includes("T") &&
      relativeTime.includes("Z")
    ) {
      const parsed = new Date(relativeTime);
      if (!isNaN(parsed.getTime())) {
        return parsed;
      }
    }

    // Otherwise, parse relative time
    const time = new Date();
    const numberPattern = /\d+/g;
    const value = parseInt(relativeTime.match(numberPattern)?.[0] || "0", 10);

    if (relativeTime.includes("second")) {
      time.setSeconds(time.getSeconds() - value);
    } else if (relativeTime.includes("minute")) {
      time.setMinutes(time.getMinutes() - value);
    } else if (relativeTime.includes("hour")) {
      time.setHours(time.getHours() - value);
    } else if (relativeTime.includes("day")) {
      time.setDate(time.getDate() - value);
    } else if (relativeTime.includes("week")) {
      time.setDate(time.getDate() - value * 7);
    } else if (relativeTime.includes("month")) {
      time.setMonth(time.getMonth() - value);
    } else if (relativeTime.includes("year")) {
      time.setFullYear(time.getFullYear() - value);
    } else {
      try {
        const parsedDate = new Date(relativeTime);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate;
        }
      } catch (e) {
        console.warn("Could not parse date:", relativeTime);
      }
      return new Date();
    }

    return time;
  }

  categorizeNotifications() {
    this.notificationsToday = this.notificationsarray.filter((notification) =>
      this.isToday(
        this.parseRelativeTime(
          notification.notification.OriginalCreatedDate ||
            notification.notification.CreatedDate
        )
      )
    );

    this.notificationsYesterday = this.notificationsarray.filter(
      (notification) =>
        this.isYesterday(
          this.parseRelativeTime(
            notification.notification.OriginalCreatedDate ||
              notification.notification.CreatedDate
          )
        )
    );

    this.notificationsThisWeek = this.notificationsarray.filter(
      (notification) => {
        const notificationDate = this.parseRelativeTime(
          notification.notification.OriginalCreatedDate ||
            notification.notification.CreatedDate
        );
        return (
          this.isThisWeek(notificationDate) &&
          !this.isToday(notificationDate) &&
          !this.isYesterday(notificationDate)
        );
      }
    );

    this.notificationsOlder = this.notificationsarray.filter((notification) => {
      const notificationDate = this.parseRelativeTime(
        notification.notification.OriginalCreatedDate ||
          notification.notification.CreatedDate
      );
      return (
        this.isOlder(notificationDate) && !this.isThisWeek(notificationDate)
      );
    });
  }

  isToday(date: Date): boolean {
    return date.toDateString() === this.today.toDateString();
  }

  isYesterday(date: Date): boolean {
    return date.toDateString() === this.yesterday.toDateString();
  }

  isThisWeek(date: Date): boolean {
    return date > this.thisWeekStart && date <= this.today;
  }

  isOlder(date: Date): boolean {
    return date < this.thisWeekStart;
  }

  markAsRead(notification: any) {
    if (notification.notification.NotificationSeen) {
      return;
    }

    // Build API payload BEFORE the optimistic update so the backend receives
    // NotificationSeen: false and its guard (item.NotificationSeen != true) is satisfied.
    const transformedNotification = {
      ...notification.notification,
      NotificationSeen: false,
      CreatedDate:
        notification.notification.OriginalCreatedDate ||
        new Date().toISOString(),
    };

    // Optimistic UI update
    notification.notification.NotificationSeen = true;
    this.notificationCount = this.notificationsarray.filter(
      (n) => !n.notification.NotificationSeen
    ).length;
    this.showNotificationCount = this.notificationCount > 0;
    this.categorizeNotifications();

    this.flowServiceService
      .MarkAsReadNotifications([transformedNotification])
      .subscribe(
        () => {
          this.notificationCount = this.notificationsarray.filter(
            (n) => !n.notification.NotificationSeen
          ).length;
          this.showNotificationCount = this.notificationCount > 0;
          this.cdr.detectChanges();
        },
        (error) => {
          console.error("Error marking notification as read:", error);
          // Revert optimistic update on error
          notification.notification.NotificationSeen = false;
          this.notificationCount = this.notificationsarray.filter(
            (n) => !n.notification.NotificationSeen
          ).length;
          this.showNotificationCount = this.notificationCount > 0;
          this.categorizeNotifications();
          this.cdr.detectChanges();
        }
      );
  }

  markAllAsRead() {
    const unreadNotifications = this.notificationsarray.filter(
      (n) => !n.notification.NotificationSeen
    );

    if (unreadNotifications.length === 0) {
      return;
    }

    // Build API payload BEFORE the optimistic update so backend receives NotificationSeen: false
    const transformedNotifications = unreadNotifications.map((item) => ({
      ...item.notification,
      NotificationSeen: false,
      CreatedDate: item.notification.OriginalCreatedDate || new Date().toISOString(),
    }));

    // Optimistic UI update
    unreadNotifications.forEach((n) => {
      n.notification.NotificationSeen = true;
    });
    this.notificationCount = this.notificationsarray.filter(
      (n) => !n.notification.NotificationSeen
    ).length;
    this.showNotificationCount = this.notificationCount > 0;
    this.categorizeNotifications();

    this.flowServiceService
      .MarkAsReadNotifications(transformedNotifications)
      .subscribe(
        () => {
          this.notificationCount = this.notificationsarray.filter(
            (n) => !n.notification.NotificationSeen
          ).length;
          this.showNotificationCount = this.notificationCount > 0;
          this.categorizeNotifications();
          this.cdr.detectChanges();
        },
        (error) => {
          console.error("Error marking all notifications as read:", error);
          // Revert optimistic update on error
          unreadNotifications.forEach((n) => {
            n.notification.NotificationSeen = false;
          });
          this.notificationCount = this.notificationsarray.filter(
            (n) => !n.notification.NotificationSeen
          ).length;
          this.showNotificationCount = this.notificationCount > 0;
          this.categorizeNotifications();
          this.cdr.detectChanges();
        }
      );
  }

  /** Avatar: profile-routed notifications open notifier profile; others follow row navigation. */
  onNotificationAvatarClick(notification: any, event: Event): void {
    event.stopPropagation();
    if (shouldAvatarOpenProfile(notification?.notification)) {
      this.navigateToNotifierProfile(notification);
    } else {
      this.navigateToContent(notification);
    }
  }

  navigateToNotifierProfile(notification: any): void {
    const n = notification?.notification;
    const email = (n?.NotifierUserEmail || "").trim();
    if (!email) {
      this.toastr.info("Profile is unavailable.");
      return;
    }
    this.markAsRead(notification);
    if (this.userData?.emailAddress === email) {
      this.router.navigate(["/user-profile"]);
    } else {
      this.router.navigate(["/view-profile"]);
    }
    this.dataService.flowByCategorieschangeMessage(n);
  }

  navigateToContent(notification: any) {
    if (!this.isNotificationClickable(notification)) {
      this.toastr.info("This content is no longer available.");
      return;
    }

    this.markAsRead(notification);

    if (this.orgNotificationService.open(notification.notification)) {
      return;
    }

    if (notification.notification.ContentType === "Flow") {
      const flowId = this.getNavigableContentId(notification);
      if (flowId) {
        localStorage.setItem("notificationflowId", flowId);
        localStorage.setItem("flow", null);
        const title = notification.notification.ContentTitle || "flow";
        const slug = this.generateUrlSlug(title);
        this.router.navigate([`/guide/${slug}/${flowId}`]);
      } else {
        this.toastr.info("Flow is no longer available.");
      }
    } else if (notification.notification.ContentType === "Bundle") {
      const bundleId = this.getNavigableContentId(notification);
      if (bundleId) {
        this.router.navigate([`/view-guide-pack/${bundleId}`]);
      } else {
        this.toastr.info("Bundle is no longer available.");
      }
    } else if (notification.notification.ContentType === "User Following") {
      // Handle profile navigation
      if (
        this.userData &&
        this.userData.emailAddress ===
          notification.notification.NotifierUserEmail
      ) {
        this.router.navigate(["/user-profile"]);
      } else if (notification.notification.NotifierUserEmail) {
        this.router.navigate(["/view-profile"]);
      }
      // Update data service for profile view
      if (notification.notification.NotifierUserEmail) {
        this.dataService.flowByCategorieschangeMessage(
          notification.notification
        );
      }
    } else if (notification.notification.ContentType === "Collaboration") {
      this.router.navigate(["/collaboration-requests"]);
    } else if (notification.notification.ContentType === "Consult") {
      const consultRoute = getConsultationDashboardPath(
        notification.notification,
        this.userData?.emailAddress
      );
      this.router.navigate([consultRoute]);
    } else if (notification.notification.FlowUrl) {
      window.open(notification.notification.FlowUrl, "_blank");
    }
  }

  isNotificationClickable(notification: any): boolean {
    if (notification?.notification?.IsNavigationDisabled) {
      return false;
    }

    const contentType = notification?.notification?.ContentType;
    if (contentType === "Flow" || contentType === "Bundle") {
      return !!this.getNavigableContentId(notification);
    }
    if (contentType === "Collaboration") {
      return true;
    }

    return true;
  }

  private getNavigableContentId(notification: any): string | null {
    const contentId = notification?.notification?.ContentId;
    if (contentId != null && String(contentId).trim() !== "") {
      return String(contentId).trim();
    }

    const fallbackId = notification?.notification?.FlowId;
    if (
      fallbackId != null &&
      String(fallbackId).trim() !== "" &&
      !String(fallbackId).includes("@")
    ) {
      return String(fallbackId).trim();
    }

    return null;
  }


  generateUrlSlug(html: string): string {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .toLowerCase();
  }

  getProfileUser(): void {
    if (this.userData != null) {
      this.showNotificationCount = true;
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
      });
    }
  }

  createFlow() {
    this.router.navigate(["/create-guide"]);
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
    this.router.navigate(["/"]);
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  getThumbnailUrl(notification: any): string {
    if (notification.notification.VideoFlowPosterImageUrl) {
      return notification.notification.VideoFlowPosterImageUrl;
    }
    if (notification.notification.FlowUrl) {
      // Check if it's an image
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp"];
      const url = notification.notification.FlowUrl.toLowerCase();
      if (imageExtensions.some((ext) => url.includes(ext))) {
        return notification.notification.FlowUrl;
      }
    }
    return null;
  }

  /** Flow-linked consultation: API sets ContentId to flow row key + cover URLs; thumbnail opens the flow. */
  isConsultationFlowThumbnailClickable(notification: any): boolean {
    if (!this.isConsultationNotification(notification)) {
      return false;
    }
    const id = (notification?.notification?.ContentId || "").toString().trim();
    if (!id || id.includes("@")) {
      return false;
    }
    return !!this.getThumbnailUrl(notification);
  }

  /** Flow-linked collaboration: thumbnail on collaboration notifications opens the associated flow. */
  isCollaborationFlowThumbnailClickable(notification: any): boolean {
    if (notification?.notification?.ContentType !== "Collaboration") {
      return false;
    }
    const id = (notification?.notification?.ContentId || "").toString().trim();
    if (!id || id.includes("@")) {
      return false;
    }
    return !!this.getThumbnailUrl(notification);
  }

  onNotificationThumbnailClick(event: Event, notification: any): void {
    const isClickable =
      this.isConsultationFlowThumbnailClickable(notification) ||
      this.isCollaborationFlowThumbnailClickable(notification);
    if (!isClickable) {
      return;
    }
    event.stopPropagation();
    const flowId = String(notification.notification.ContentId).trim();
    const title = notification.notification.ContentTitle || "flow";
    const slug = this.generateUrlSlug(title);
    this.markAsRead(notification);
    localStorage.setItem("notificationflowId", flowId);
    localStorage.setItem("flow", null);
    this.router.navigate([`/guide/${slug}/${flowId}`]);
  }

  getAvatarUrl(notification: any): string {
    const url = (notification?.notification?.ProfilePicUrl || "").trim();
    return url ? url : this.defaultProfileImageUrl;
  }

  getAvatarInitial(notification: any): string {
    const userName = notification.notification.NotifierUserName || "U";
    return userName[0].toUpperCase();
  }

  onAvatarError(event: Event): void {
    const img = event?.target as HTMLImageElement | null;
    if (!img) return;

    // Prevent infinite error loops if the default image is also missing.
    if (img.src && img.src.includes(this.defaultProfileImageUrl)) return;

    img.onerror = null;
    img.src = this.defaultProfileImageUrl;
  }

  isConsultationNotification(notification: any): boolean {
    return notification?.notification?.ContentType === "Consult";
  }

  consultationFlowTitle(notification: any): string {
    const title = (notification?.notification?.ContentTitle || "").toString().trim();
    return title;
  }

  /**
   * Show content title for consultation notifications when it looks like a real title
   * (not a user handle/email fallback used by profile-based consultations).
   */
  shouldShowConsultationFlowTitle(notification: any): boolean {
    if (!this.isConsultationNotification(notification)) {
      return false;
    }

    const title = this.consultationFlowTitle(notification);
    if (!title) {
      return false;
    }

    if (this.isLikelyHandleOrEmail(title)) {
      return false;
    }

    const notifier = (notification?.notification?.NotifierUserName || "")
      .toString()
      .trim();
    if (notifier && this.normalizeLooseIdentity(title) === this.normalizeLooseIdentity(notifier)) {
      return false;
    }

    return true;
  }

  private isLikelyHandleOrEmail(value: string): boolean {
    const v = (value || "").trim();
    if (!v) {
      return false;
    }
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      return true;
    }
    if (v.startsWith("@")) {
      return true;
    }
    return false;
  }

  private normalizeLooseIdentity(value: string): string {
    return (value || "").trim().replace(/^@+/, "").toLowerCase();
  }

  /** Hide "Add to calendar" when the consultation slot has already ended (uses same date/time logic as ICS). */
  showConsultationAddToCalendar(notification: any): boolean {
    if (!this.isConsultationNotification(notification)) {
      return false;
    }
    const n = notification?.notification || {};
    const dateRaw =
      n.consultationCalendarDate ?? n.ConsultationCalendarDate ?? "";
    const timeRaw =
      n.consultationCalendarTime ?? n.ConsultationCalendarTime ?? "";
    const slotRaw =
      n.consultationCalendarSlot ?? n.ConsultationCalendarSlot ?? "";
    if (!String(dateRaw).trim()) {
      return true;
    }
    const range = getConsultationStartEnd({
      selectedDate: dateRaw,
      selectedTime: timeRaw,
      selectedTimeSlot: slotRaw,
    });
    if (!range?.end) {
      return true;
    }
    return range.end.getTime() > Date.now();
  }

  getNotificationMessage(notification: any): string {
    const rawMessage = notification?.notification?.Message || "";
    const consultNav = (
      notification?.notification?.ConsultationNavTarget || ""
    )
      .toString()
      .trim()
      .toLowerCase();
    if (
      this.isConsultationNotification(notification) &&
      (consultNav === "booker" || consultNav === "host")
    ) {
      return rawMessage;
    }

    const loggedInEmail = (this.userData?.emailAddress || "").toLowerCase();

    // Replace references to the logged-in user with "You"
    // regardless of notifier email direction.
    const loggedInUserName = (this.userData?.userName || "").trim();
    const loggedInFirstName = (this.userData?.firstName || "").trim();
    const loggedInCustomerEmail = (this.userData?.customerEmail || "").trim().toLowerCase();
    const emailLocalPart = (loggedInEmail.split("@")[0] || "").trim();
    const customerEmailLocalPart = (
      loggedInCustomerEmail.split("@")[0] || ""
    ).trim();

    const fullEmails = Array.from(
      new Set([loggedInEmail, loggedInCustomerEmail].filter((v) => !!v))
    );

    // Longest first so "Jane Doe" is replaced before "Jane".
    const candidates = Array.from(
      new Set(
        [
          loggedInUserName,
          loggedInFirstName,
          emailLocalPart,
          customerEmailLocalPart,
        ]
          .map((v) => (v || "").trim())
          .filter((v) => !!v)
      )
    ).sort((a, b) => b.length - a.length);

    const escape = (v: string) => v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    let message = rawMessage;
    // Full emails before name parts, otherwise "john@gmail.com" becomes "You@gmail.com".
    for (const email of fullEmails) {
      message = message.replace(new RegExp(escape(email), "gi"), "You");
    }
    for (const name of candidates) {
      const escaped = escape(name);
      // Replace both "name" and "@name" mentions.
      message = message
        .replace(new RegExp(`@${escaped}`, "gi"), "You")
        .replace(new RegExp(`\\b${escaped}\\b`, "gi"), "You");
    }

    return this.normalizeYouNotificationPhrasing(message);
  }

  /**
   * After replacing usernames with "You", fix awkward leftovers like "You user has…".
   */
  private normalizeYouNotificationPhrasing(message: string): string {
    let m = message;

    const youUserVerb: Array<[RegExp, string]> = [
      [/\bYou\s+user\s+has\b/gi, "You have"],
      [/\bYou\s+user\s+had\b/gi, "You had"],
      [/\bYou\s+user\s+is\b/gi, "You are"],
      [/\bYou\s+user\s+was\b/gi, "You were"],
      [/\bYou\s+user\s+will\b/gi, "You will"],
      [/\bYou\s+user\s+would\b/gi, "You would"],
      [/\bYou\s+user\s+can\b/gi, "You can"],
      [/\bYou\s+user\s+could\b/gi, "You could"],
      [/\bYou\s+user\s+should\b/gi, "You should"],
      [/\bYou\s+user\s+may\b/gi, "You may"],
      [/\bYou\s+user\s+might\b/gi, "You might"],
      [/\bYou\s+user\s+must\b/gi, "You must"],
      [/\bYou\s+user\s+needs?\b/gi, "You need"],
      [/\bYou\s+customer\s+has\b/gi, "You have"],
      [/\bYou\s+customer\s+had\b/gi, "You had"],
      [/\bYou\s+customer\s+is\b/gi, "You are"],
      [/\bYou\s+customer\s+was\b/gi, "You were"],
    ];

    for (const [pattern, replacement] of youUserVerb) {
      m = m.replace(pattern, replacement);
    }

    // Remaining "You user …" / "You customer …" → "You …"
    m = m.replace(/\bYou\s+user\s+/gi, "You ");
    m = m.replace(/\bYou\s+customer\s+/gi, "You ");
    m = m.replace(/\bYou\s+user\b/gi, "You");
    m = m.replace(/\bYou\s+customer\b/gi, "You");

    // Leftover email domain: "You@gmail.com" → "You"
    m = m.replace(/\bYou@[\w.-]+\.[a-z]{2,}\b/gi, "You");
    // Name + email pairs: "You (You)", "You <You>", "You - You", "You You" → "You"
    m = m.replace(/\bYou\s*[(<[]\s*You\s*[)>\]]/gi, "You");
    m = m.replace(/\bYou\s*[-–—,:]\s*You\b/gi, "You");
    m = m.replace(/\bYou(\s+You\b)+/gi, "You");
    // Mid-sentence "by You" reads better lower-case.
    m = m.replace(/([^.!?\s]\s+)You\b/g, (_match, before: string) => `${before}you`);

    return m.replace(/\s{2,}/g, " ").trim();
  }

  private getConsultationRowKeyFromNotification(notification: any): string | null {
    const raw =
      notification?.notification?.FlowId ||
      notification?.notification?.ContentId;
    const id = raw != null ? String(raw).trim() : "";
    if (!id || id.includes("@")) {
      return null;
    }
    return id;
  }

  addConsultationToCalendarFromNotification(
    notification: any,
    event: Event
  ): void {
    event.stopPropagation();
    event.preventDefault();
    const rowKey = this.getConsultationRowKeyFromNotification(notification);
    if (!rowKey) {
      this.toastr.info(
        "Open Initiated or Received consultations in your dashboard to add this booking to your calendar."
      );
      return;
    }
    const qm = new FlowQueryModel({ rowKey });
    this.flowServiceService.getConsultationByRowKey(qm).subscribe({
      next: (data) => {
        if (!data || !canBuildConsultationCalendarEvent(data)) {
          this.toastr.error(
            "Could not load consultation details for your calendar."
          );
          return;
        }
        this.consultationCalendarDialog.open(data);
      },
      error: () => {
        this.toastr.error(
          "Could not load consultation details for your calendar."
        );
      },
    });
  }
}
